import { render, staticRenderFns } from "./control-font-size.vue?vue&type=template&id=464f07a4&"
import script from "./control-font-size.vue?vue&type=script&lang=js&"
export * from "./control-font-size.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports